
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.312 7.25l-.224 3.07c.32 0 .46-.133.626-.295l1.502-1.4 3.113 2.223c.57.31.973.147 1.127-.512l2.043-9.334c.182-.824-.304-1.145-.86-.944L.629 4.542c-.82.31-.808.755-.14.957l3.07.931 7.133-4.35c.335-.217.64-.098.39.12l-5.77 5.05z","fill":"#000"}})])
          )
        }
      }
    